module.exports = __webpack_public_path__ + "static/media/ConferenceYear2019.c5940d6c.png";